import { useEffect } from 'react';
import { useQuery, skipToken } from '@apollo/client/react';
import { useParams } from 'react-router';

import {
    IUserListItemFragment,
    IUserSelectorQueryVariables,
    GroupManagersDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export interface IUserList {
    users: IUserListItemFragment[];
    alreadyAddedUsers: string[];
    usersCount?: number | null;
    loading: boolean;
}

export const useGroupManagersList = (
    userQueryVariables?: IUserSelectorQueryVariables,
    skip?: boolean
): IUserList => {
    const { showApolloError } = useApolloError();
    const { id: groupId } = useParams() as { id: string };
    const { loading, data, error } = useQuery(
        GroupManagersDocument,
        skip
            ? skipToken
            : {
                  variables: {
                      id: groupId,
                      q: userQueryVariables?.q,
                      offset: userQueryVariables?.offset,
                      ...userQueryVariables,
                  },
                  notifyOnNetworkStatusChange: true,
              }
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const usersObject = data?.group?.managers;
    const usersCount = usersObject?.count;
    const users =
        usersObject?.edges.map((edge) => edge?.node || null).filter(Boolean) ||
        [];

    return {
        users,
        alreadyAddedUsers: [],
        usersCount,
        loading,
    };
};
